import React from 'react';

const FinishIcon = ({ ...props }) => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" {...props}>
    <path
      d="M10.5625 5.33333C10.5625 5.225 10.4975 5.12479 10.3946 5.08417L4.0625 2.44354V2.08333C4.0625 1.93438 3.94063 1.8125 3.79167 1.8125C3.64271 1.8125 3.52083 1.93438 3.52083 2.08333V2.625V8.03896V12.6431H2.70833C2.55938 12.6431 2.4375 12.765 2.4375 12.914C2.4375 13.0629 2.55938 13.1848 2.70833 13.1848H4.875C5.02396 13.1848 5.14583 13.0629 5.14583 12.914C5.14583 12.765 5.02396 12.6431 4.875 12.6431H4.0625V8.22313L10.3946 5.58521C10.4975 5.54188 10.5625 5.44167 10.5625 5.33333ZM4.0625 7.63542V3.03125L9.5875 5.33333L4.0625 7.63542Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.4"
    />
  </svg>
);

export default FinishIcon;
